import Link from 'next/link';

import styled from 'styled-components';

import { CenterChildren } from 'styles/layouts';

export const IconWrapper = styled(CenterChildren)`
  display: inline-flex;
`;

export const StyledLink = styled(Link)`
  display: inline-flex;
  align-items: center;

  ${IconWrapper} {
    margin-left: -4px;
  }
}`;
